import React from 'react'

import { Box, Button, Icon, Tag, Text } from '@factorialco/deprecated-design-system'

import QuestionIcon from 'modules/questionnaires/components/QuestionIcon'
import { getQuestionTypeSelector } from 'modules/questionnaires/lib/helpers'
import { Question, Translations } from 'modules/questionnaires/lib/types'

import * as style from './index.vanilla.css'

type Props = {
  question: Question
  translations: Translations['question']
  disabled?: boolean
  duplicateDisabled?: boolean
  locked?: boolean
  onEdit: () => void
  onDuplicate: () => void
}

const QuestionHeader: React.FC<Props> = ({
  question,
  translations,
  disabled = false,
  duplicateDisabled = false,
  locked = false,
  onEdit,
  onDuplicate,
}) => {
  const newlineIndex = question.title.indexOf('\n')
  const questionHeadderText =
    newlineIndex !== -1 ? question.title.substring(0, newlineIndex) + '...' : question.title

  const handleDuplicate = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onDuplicate()
  }

  return (
    <Box
      className={locked ? style.lockedCard : style.card}
      width="full"
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      borderRadius={{ all: 'abs008' }}
      flexDirection="row"
      alignItems="center"
      position="relative"
      paddingY="s16"
      paddingLeft={locked ? 's32' : 's4'}
      paddingRight="s32"
      gap="s4"
      aria-label={translations.actions.edit}
      onClick={locked ? undefined : () => !disabled && onEdit()}
    >
      {!locked && (
        <Box className={style.dragIcon}>
          <Icon.Medium icon="drag-and-drop" color="grey800" />
        </Box>
      )}
      <Box flexDirection="row" gap="s16" alignItems="center" flexGrow>
        <QuestionIcon type={getQuestionTypeSelector(question)} />
        <Text.Normal ellipsis weight="medium" lineClamp={2} overflowWrap>
          {questionHeadderText}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" gap="s16" alignItems="center">
        {question.mandatory && <Tag type="champagne">{translations.mandatory}</Tag>}
        {!locked && (
          <Button
            iconName="duplicate"
            type="secondary"
            title={translations.actions.duplicate}
            aria-label={translations.actions.duplicate}
            disabled={duplicateDisabled}
            onClick={handleDuplicate}
          />
        )}
      </Box>
    </Box>
  )
}
export default QuestionHeader
